export enum SiteTableFilters {
  CountryCode = "countryCode",
}
